import { render, staticRenderFns } from "./create-threshold.vue?vue&type=template&id=64ed56d0&"
import script from "./create-threshold.vue?vue&type=script&lang=ts&"
export * from "./create-threshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports